import styled, { css } from 'styled-components';
import { ButtonElem as BaseButton } from '../../components/Button';
import homeBackground from '../../assets/backgrounds/home.png';
import { onVerticalScreen } from '../../utils/css';

export const HomeContainer = styled.main`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  overflow: hidden;
  background: url(${homeBackground}), ${({ theme }) => theme.colors.background};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  & > div:first-of-type {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  h1,
  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.citiSans};
    font-weight: 400;
    margin-top: ${({ theme }) => `${theme.getValue(14)}`};
  }

  h1 {
    max-width: ${({ theme }) => `${theme.getValue(110)}`};
    margin-bottom: ${({ theme }) => theme.getValue(14)};
    font-size: ${({ theme }) => theme.getFontSize(50)};
    line-height: 0.82;
  }

  h2 {
    margin-bottom: ${({ theme }) => `${theme.getValue(37)}`};
    font-size: ${({ theme }) => `${theme.getFontSize(30)}`};
    line-height: ${({ theme }) => `${theme.getFontSize(40)}`};
  }

  ${onVerticalScreen(css`
    flex-direction: column;
    gap: ${({ theme }) => `${theme.getValue(130)}`};

    h1 {
      margin-bottom: ${({ theme }) => `${theme.getValue(28)}`};
      font-size: ${({ theme }) => `${theme.getFontSize(74)}`};
      line-height: ${({ theme }) => `${theme.getValue(68)}`};
      max-width: ${({ theme }) => `${theme.getValue(330)}`};
    }

    h2 {
      margin-bottom: ${({ theme }) => theme.getValue(68)};
      font-size: ${({ theme }) => `${theme.getFontSize(50)}`};
      line-height: ${({ theme }) => theme.getValue(60)};
    }

    img {
      width: ${({ theme }) => `${theme.getValue(260)}`};
      height: ${({ theme }) => `${theme.getValue(168)}`};
    }
  `)}
`;

export const LinkButton = styled(BaseButton)`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  text-decoration: none;
  margin: 0;
  border: none;
  min-width: ${({ theme }) => `${theme.getValue(293)}`};
  min-height: ${({ theme }) => `${theme.getValue(60)}`};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  font-weight: 700;

  ${({ theme }) =>
    onVerticalScreen(css`
      padding: ${`${theme.getValue(32)} ${theme.getValue(64)}`};
      min-width: ${`${theme.getValue(500)}`};
    `)}
`;

export const LeftContent = styled.div`
  width: ${({ theme }) => `${theme.getValue(425)}`};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${onVerticalScreen(css`
    width: ${({ theme }) => `${theme.getValue(600)}`};
  `)}
`;
